import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  button: ({ size }) => ({
    '& > *': {
      height: size,
      width: size,
    },
  }),
});

export default useStyles;
